(function(){
    angular
        .module('appback')
        .directive('ngCompilartabla', ngCompilartabla);

        ngCompilartabla.$inject = ['ResultadosService','$timeout','$compile'];
        function ngCompilartabla(ResultadosService,$timeout,$compile){
            return {
	            templateUrl: '/backend/web/app/views/tabla.html',
	            //require: 'ngModel',
		          scope: {
                  //ngModel : '=',
                  //item: '=',
                  //animal: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	//console.log("ENTRO");
		            	//var str = $('#pjax-grid-view').html();//'<button class="btn btn-default" ng-click="lc.resultados(769078)">prueba</button>';
						//scope.html = str;
						//console.log(scope);
						scope.lc = scope.$parent.lc;
						$('#pjax-grid-view').bind("DOMSubtreeModified", function() {
							if($(this).find("tbody").html()!=""){
							//console.log("ENTRO2");
	       						//$compile($(this).contents())(scope);
								var template = angular.element($(this).find("tbody").html());
								element.append(template);
								$compile(element)(scope);
								//scope.html = '<button class="btn btn-default" ng-click="lc.resultados(769078)">prueba</button>';


								////console.log("compilando HTML");
	     						/*var gridHtml =  $(this).html();
	       						//element.after("<div class='panel' >"+gridHtml+"</div>");
	       						element.html($(this).html());
	       						$compile(element.contents())(scope);
	       						//console.log($(this).contents());
								//element.html($(this).html());
								//$compile(element.contents())(scope);
				            	////console.log("ENTR2O");*/
				            }
						});
		            	//
		            })
		        }
          }
      }
})();